/**
 *  @deprecated
 * Use NumberUtil instead (which NumberFormat is a wrapper of, anyway.)
 */
define(function(require) {
	var NumberUtil = require('./NumberUtil').default;
	var format = NumberUtil.format;

	var NumberFormat = {
		formatBigNumbers: format
	};

	// TODO: evaluate application in code
	NumberFormat.formatInteger = function(val) {
		return format(val, 0);
	};

	NumberFormat.formatFloat = function(val, showSign, numDecimal) {
		return format(val, numDecimal, showSign);
	};

	NumberFormat.format = function(value, range, s, numDecimal) {
		if (range && range.toLowerCase() === 'int') return NumberFormat.formatInteger(value);
		if (range && range.toLowerCase() === 'float') return format(value, numDecimal, s);
		return value;
	};

	// tick format for frequency with grouping by thousands and millions
	NumberFormat.tickFormatFrequency = function(d, isFloat, numDecimal) {
		return format.tick(d, isFloat ? numDecimal : 0);
	};

	// tick format for sentiment with comma grouping
	NumberFormat.tickFormatSentiment = function(d, showSign) {
		return format.tick(d, 2, showSign);
	};

	// tick format for share of voice with comma grouping
	NumberFormat.tickFormatShareOfVoice = function(d, numDecimal) {
		return format.tick(d, numDecimal || numDecimal === 0 ? numDecimal : 2);
	};

	/**
	 * tries to abbreviate large numbers (int or float)
	 * in case of large float number, rounds to full int
	 */
	NumberFormat.abbreviate = function(num, skipEnding) {
		return format.suffix(num, null, !skipEnding);
	};

	/**
	 * Abbreviates a large number with 'k' or 'm'
	 */
	NumberFormat.abbreviateInteger = function(num, skipEnding) {
		return format.suffix(num, 0, !skipEnding);
	};

	/**
	 * Sometimes (e.g. when coloring) the ending is needed extra
	 */
	NumberFormat.getAbbrevationEnding = function(num) {
		return NumberUtil.suffix(num, 3);
	};

	return NumberFormat;
});
